import {
  POST_UPLOAD_FILE,
  POST_UPLOAD_FILE_SUCCESS,
  POST_UPLOAD_FILE_FAIL,
  MODIFY_MAILS,
  MODIFY_MAILS_SUCCESS,
  MODIFY_MAILS_FAIL,
  GET_RECIPIENTS_TO_MAILS,
  GET_RECIPIENTS_TO_MAILS_FAIL,
  GET_RECIPIENTS_TO_MAILS_SUCCESS,
  DISPLAY_SENT_NOTIFICATION_MAILS,
  SEND_INBOX_MAILS,
  SEND_INBOX_MAILS_SUCCESS,
  SEND_INBOX_MAILS_FAIL,
  SET_CURRENT_EMAIL_MAILS,
  GET_INBOX_MAILS,
  GET_INBOX_MAILS_FAIL,
  GET_INBOX_MAILS_SUCCESS,
  ADD_NEW_INBOX_MAIL,
  ADD_INBOX_MAIL_SUCCESS,
  ADD_INBOX_MAIL_FAIL,
  DELETE_INBOX_MAIL,
  DELETE_INBOX_MAIL_SUCCESS,
  DELETE_INBOX_MAIL_FAIL,
  GET_STARRED_MAILS,
  GET_STARRED_MAILS_FAIL,
  GET_STARRED_MAILS_SUCCESS,
  GET_IMPORTANT_MAILS,
  GET_IMPORTANT_MAILS_FAIL,
  GET_IMPORTANT_MAILS_SUCCESS,
  GET_TRASH_MAILS,
  GET_TRASH_MAILS_FAIL,
  GET_TRASH_MAILS_SUCCESS,
  GET_DRAFT_MAILS,
  GET_DRAFT_MAILS_FAIL,
  GET_DRAFT_MAILS_SUCCESS,
  GET_SENT_MAILS,
  GET_SENT_MAILS_FAIL,
  GET_SENT_MAILS_SUCCESS,
  DELETE_MAIL_MAILS,
  DELETE_MAIL_MAILS_SUCCESS,
  DELETE_MAIL_MAILS_FAIL,
  UPDATE_DATAINBOX_MAILS,
} from "./actionTypes"

const INIT_STATE = {
  currentEmail: {},
  displayNotification: false,
  datainbox: {
    unread: 0,
    currentpage: 0,
    pagesize: 0,
    totalmails: 0,
    idcurrentmail: -1,
    mailselected: [],
  },
  inboxmails: [],
  starredmails: [],
  importantmails: [],
  draftmails: [],
  sentmails: [],
  trashmails: [],
  listasDistribucionTo: [],
  error: {},
  displayNotification: undefined,
  loading: false,
}

const Mails = (state = INIT_STATE, action) => {
  switch (action.type) {
    case MODIFY_MAILS_SUCCESS:
      switch (action.actionSuccess) {
        case MARK_AS_READ_MAILS_SUCCESS:
          return { ...state, response: action.payload }
        case MARK_AS_UNREAD_MAILS_SUCCESS:
          return { ...state, response: action.payload }
        default:
          return state
      }

    case UPDATE_DATAINBOX_MAILS:
      return { ...state, datainbox: action.payload }

    case MODIFY_MAILS_FAIL:
      return { ...state, error: action.payload }

    case GET_RECIPIENTS_TO_MAILS_SUCCESS:
      return { ...state, listasDistribucionTo: action.payload }

    case GET_RECIPIENTS_TO_MAILS_FAIL:
      return { ...state, error: action.payload }

    case DISPLAY_SENT_NOTIFICATION_MAILS:
      return { ...state, displayNotification: action.payload }

    case SEND_INBOX_MAILS_SUCCESS:
      return {
        ...state,
        displayNotification: action.payload,
      }

    case SEND_INBOX_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
        displayNotification: action.payload,
      }

    case SET_CURRENT_EMAIL_MAILS:
      return {
        ...state,
        currentEmail: action.payload,
        activeTab: 7,
      }

    case GET_INBOX_MAILS_SUCCESS:
      return {
        ...state,
        inboxmails: action.payload,
        datainbox: action.datainbox,
      }

    case GET_INBOX_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_INBOX_MAIL_SUCCESS:
      return {
        ...state,
        inboxmails: [...state.inboxmails, action.payload],
      }

    case ADD_INBOX_MAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_INBOX_MAIL_SUCCESS:
      return {
        ...state,
        inboxmails: state.inboxmails.filter(
          user => user.id.toString() !== action.payload.id.toString()
        ),
      }

    case DELETE_INBOX_MAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_STARRED_MAILS_SUCCESS:
      return {
        ...state,
        starredmails: action.payload,
      }

    case GET_STARRED_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_IMPORTANT_MAILS_SUCCESS:
      return {
        ...state,
        importantmails: action.payload,
      }

    case GET_IMPORTANT_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_TRASH_MAILS_SUCCESS:
      return {
        ...state,
        trashmails: action.payload,
      }

    case GET_TRASH_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_DRAFT_MAILS_SUCCESS:
      return {
        ...state,
        draftmails: action.payload,
      }

    case GET_DRAFT_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SENT_MAILS_SUCCESS:
      return {
        ...state,
        sentmails: action.payload,
      }

    case GET_SENT_MAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default Mails
